module.exports = __webpack_public_path__ + "static/debit_card_passport-b0ee4621f115a87c02279c00e70ab5c6.pdf";